(function() {
    'use strict';

    angular.module('order')
        .controller('OrderDeliveryUpdateModalController', OrderDeliveryUpdateModalController);

    OrderDeliveryUpdateModalController.$inject = ['lodashService', 'orderDataSrvc', 'notificationSrvc', 'errorNotificationSrvc', '$uibModalInstance', 'order'];

    function OrderDeliveryUpdateModalController(lodashService, orderDataSrvc, notificationSrvc, errorNotificationSrvc, $uibModalInstance, order) {
        var self = this;

        self.order = order;
        self.order.target_point_name = null;
        self.isLockerService = false;
        self.deliveryOptions = [];
        self.serverErrors = {};
        self.isSubmitting = false;

        self.cleanErrors = cleanErrors;
        self.ok = ok;
        self.updateDelivery = updateDelivery;
        self.deliveryChanged = deliveryChanged;

        activate();

        function activate() {
            var deliveryAddress = lodashService.first(order.delivery_addresses);
            self.order.target_point_name = lodashService.get(deliveryAddress, 'target_point.name', null);

            orderDataSrvc.deliveryOptions({
                pk: order.pk
            }).$promise.then(function (response) {
                self.deliveryOptions = response.options;
                deliveryChanged();
            });
        }

        function ok() {
            self.order = null;
            $uibModalInstance.dismiss('cancel');
        }

        function updateDelivery() {
            self.isSubmitting = true;

            orderDataSrvc.updateExternal({
                pk: order.pk
            }, {
                ups_delivery_service: order.ups_delivery_service,
                target_point_name: order.target_point_name
            }).$promise.then(
                function () {
                    $uibModalInstance.close();
                },
                function (response) {
                    self.isSubmitting = false;
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function deliveryChanged() {
            self.isLockerService = !!(
                self.order.ups_delivery_service &&
                self.order.ups_delivery_service.indexOf('inpost_locker_') === 0
            );

            if (!self.isLockerService) {
                self.order.target_point_name = null;
                delete self.serverErrors.target_point_name;
            }
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
